import React from "react";

const getInitials = (name = "") =>
  name.trim().split(" ").slice(0, 2).map((w) => w[0]?.toUpperCase() || "").join("") || "?";

const AVATAR_COLORS = ["#6366f1", "#8b5cf6", "#0891b2", "#059669", "#db2777", "#0284c7", "#7c3aed"];
const getAvatarColor = (name = "") => AVATAR_COLORS[(name.charCodeAt(0) || 0) % AVATAR_COLORS.length];

const SavingsIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="17" height="17" style={{ marginRight: 7, flexShrink: 0 }}>
    <path fillRule="evenodd" clipRule="evenodd" d="M14.2929 1.29289C14.6834 0.902369 15.3166 0.902369 15.7071 1.29289L23.7071 9.29289C24.0976 9.68342 24.0976 10.3166 23.7071 10.7071L18 16.4142V19C18 20.6569 16.6569 22 15 22H5C2.23858 22 0 19.7614 0 17V8C0 5.79086 1.79086 4 4 4H11.5858L14.2929 1.29289ZM9.58579 6H4C2.89543 6 2 6.89543 2 8V17C2 18.6569 3.34315 20 5 20H15C15.5523 20 16 19.5523 16 19V16.0007C16 16.0002 16 15.9998 16 15.9993V11C16 10.4477 15.5523 10 15 10H8.00069C8.00023 10 7.99977 10 7.99931 10H5C3.89543 10 3 9.10457 3 8V7.5C3 6.94772 3.44772 6.5 4 6.5C4.55228 6.5 5 6.94772 5 7.5V8H7.58579L9.58579 6ZM10.4142 8H15C16.6569 8 18 9.34315 18 11V13.5858L21.5858 10L15 3.41421L12.7071 5.70711L10.4142 8Z" fill="#fff" />
  </svg>
);

const MoneyBagKES = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="21" height="21" fill="none" style={{ marginRight: 7, flexShrink: 0 }}>
    <path fill="none" stroke="#fff" strokeLinecap="square" strokeMiterlimit="10" strokeWidth="1.91"
      d="M17.67,22.5H6.33A4.83,4.83,0,0,1,1.5,17.67h0a4.83,4.83,0,0,1,1.24-3.23l7.35-8.17h3.82l7.35,8.17a4.83,4.83,0,0,1,1.24,3.23h0A4.83,4.83,0,0,1,17.67,22.5Z" />
    <path fill="none" stroke="#fff" strokeLinecap="square" strokeMiterlimit="10" strokeWidth="1.91"
      d="M15.82,1.5l-.39,2A3.49,3.49,0,0,1,12,6.27h0A3.49,3.49,0,0,1,8.57,3.46l-.39-2Z" />
    <line stroke="#fff" strokeLinecap="square" strokeMiterlimit="10" strokeWidth="1.91" x1="18.68" y1="3.41" x2="14.86" y2="5.32" />
    <line stroke="#fff" strokeLinecap="square" strokeMiterlimit="10" strokeWidth="1.91" x1="19.64" y1="6.27" x2="13.91" y2="6.27" />
    <text x="12" y="20" textAnchor="middle" fontSize="7" fontWeight="800" fill="#fff" fontFamily="Arial,sans-serif">KES</text>
  </svg>
);

const Navbar = ({
  add_new_saving,
  role,
  apply_for_loan,
  signMeOut,
  showDropDown,
  openMenu,
  username,
  show_btn,
  route,
  onTaggleSidebar,
  current_app_type,
  onSwitch,
}) => (
  <nav className="navbar navbar-default navbar-static-top">
    <div className="navbar-header">
      <a href="#" className="navbar-brand">
        <a href="#" onClick={onTaggleSidebar}>
          <i className="fas fa-bars"></i>
        </a>
        <span>{route}</span>
      </a>
    </div>
    <div>
      <ul className="nav navbar-nav navbar-right">
        {role === "admin" && show_btn ? (
          <li>
            <button onClick={apply_for_loan} className="btn request_loan">
              <MoneyBagKES />
              Apply Loan
            </button>
          </li>
        ) : (
          role === "saving" && (
            <li>
              <button onClick={add_new_saving} className="btn request_loan">
                <SavingsIcon />
                New Saving
              </button>
            </li>
          )
        )}
        <li>
          <div className="profile" onClick={openMenu}>
            <div
              className="user-avatar-initials"
              style={{ background: "#F79222" }}
            >
              {getInitials(username)}
            </div>
            <div className="user-info">
              <span className="user-name">{username}</span>
              <span className="user-role">Admin</span>
            </div>
            <i className="fa fa-chevron-down user-chevron" />
            {showDropDown && (
              <div className="dropdown">
                <div className="dropdown-user-header">
                  <div
                    className="dropdown-avatar"
                    style={{ background: "#F79222" }}
                  >
                    {getInitials(username)}
                  </div>
                  <div className="dropdown-user-meta">
                    <strong>{username}</strong>
                    <span>Administrator</span>
                  </div>
                </div>
                <ul>
                  <div className="app_mobile_menus">
                    <li>{username}</li>
                    <li onClick={onSwitch}>
                      {current_app_type === "loan"
                        ? "Switch to Epesi Savings"
                        : "Switch to Epesi loans"}
                    </li>
                  </div>
                  <li onClick={onSwitch}>
                    <i className="fa fa-exchange" style={{ marginRight: 10, color: "#6366f1" }}></i>
                    {current_app_type === "loan" ? "Switch to Epesi Savings" : "Switch to Epesi Loans"}
                  </li>
                  <li onClick={signMeOut} className="signout-li">
                    <i className="fa fa-sign-out" style={{ marginRight: 10, color: "#ef4444" }}></i>
                    Sign out
                  </li>
                </ul>
              </div>
            )}
          </div>
        </li>
      </ul>
    </div>
  </nav>
);

export default Navbar;
